import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSrpDataThunk } from './redux/thunks';
import SearchWidget from './../../../shared/pages/StoriesTestPage/SrpPage/SearchWidget/SearchWidget';
import SrpMainBlock from './../../../shared/pages/StoriesTestPage/SrpPage/SrpMainBlock/SrpMainBlock';
import * as S from './../../../shared/pages/StoriesTestPage/StoriesTestPage.styles';
import { commonSelector } from './../Common/redux/selectors';
import { pushEcommerceGAEvent } from 'ga-utils';
import { useHistory } from 'react-router-dom';
import { updateSelectedBus, setNextDayPopup } from './redux/actions'
import { prepareAlternateRouteURL, fillSRPDataFromURL, replaceSRPUrlState } from './../Common/Utils'
import { getInitSelectedFilters } from './Utils';
import { moveToAlternateRoutePageSelector, dataLoadingSelector, nextDayPopupSelector } from './redux/selectors'
import NotFoundPopup from './../../../shared/pages/NotFoundPopup/NotFoundPopupUI';
import { updateJourneyParams } from './../../containers/Common/redux/actions'
import format_dateObj from './../../utils/FormatDateObj';
import { Modal } from './../../../shared/pages/common/modal';
import useOutsideClick from './../../hooks/useOutsideClick';
import { Helmet } from 'react-helmet';
import dateformat from 'dateformat';
import { clearFilterCard } from '../../pages/StoriesTestPage/SrpPage/TopFilterCards/SliderFilter/SliderCard';

const SRP = () => {

  const NotFoundPopupRef = React.createRef();
  useOutsideClick(NotFoundPopupRef, () => {
    dispatch(setNextDayPopup(false))
  });


  const history = useHistory();
  const dispatch = useDispatch();
  const commonData = useSelector(commonSelector);
  const moveToAlternateRoutePage = useSelector(moveToAlternateRoutePageSelector)
  const isDataLoading = useSelector(dataLoadingSelector);
  const showNextDayPopup = useSelector(nextDayPopupSelector);
  const { src, dest, src_vid, dest_vid, doj, dojObj, src_name, dest_name, srcLat, srcLon, destLat, destLon } = commonData;
  const [selectedFilters, setSelectedFilters] = useState(getInitSelectedFilters());
  
  const clearHorizontalFilterCards = (resetBoState) => {
    clearFilterCard(resetBoState)
  }
  let tommorrowDate = format_dateObj({ keyName: 'srpPage', value: dateformat(dojObj, 'yyyy-mm-dd') })['srpPageRaw']

  if (dojObj) {
    tommorrowDate.setDate(dojObj.getDate() + 1);
  }

  useEffect(() => {

    if (!src || !dest || !src_vid || !dest_vid) {
      fillSRPDataFromURL(dispatch, fetchSrpDataThunk, window.location.search)
    } else {
      if (src && dest && src_vid && dest_vid && dojObj) {
        dispatch(fetchSrpDataThunk({
          src,
          dest,
          src_id: src_vid,
          dest_id: dest_vid,
          doj: doj,
          src_name,
          dest_name,
          srcLat,
          srcLon,
          destLat,
          destLon
        }));
        replaceSRPUrlState({
          history,
          search: window.location.search,
          keyName: 'bid',
          inputValues: {
            src_name: src,
            dest_name: dest,
            src_vid,
            dest_vid,
            selectedDate: dojObj
          }
        })

        try {
          pushEcommerceGAEvent({
            virtualPage: history.location.pathname + history.location.search,
            pageViewEvents: {
              cdBusSearchOrigin: src,
              cdBusSearchDestination: dest,
              cdBusSearchDepartureDate: dojObj,
              cdSubCatQuery: 'OneWay',
              cdCatQuery: 'bus-domestic'
            }
          });
        } catch (err) {
          console.warn("issue in page view send")
        }
      }
    }
    return () => {
      dispatch(updateSelectedBus(''));
    }
  }, [])

  useEffect(() => {
    if (moveToAlternateRoutePage) {
      const srpURL = prepareAlternateRouteURL({ src_name: src, dest_name: dest, selectedDate: dojObj, src_vid, dest_vid });
      history.push(srpURL);
    }
  }, [moveToAlternateRoutePage])

  return (
    <>
      <Helmet
        title={"Bus Booking - Online Bus Ticket Booking of all Bus types at best prices"}
        meta={
          [{ name: 'description', content: "Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices." },
          { name: 'keywords', content: "Goibibo, online bus booking, book bus online, bus booking site, Goibibo buses" },
          { property: 'og:title', content: "Bus Booking - Online Bus Ticket Booking of all Bus types at best prices" },
          { property: 'og:description', content: "Book Bus Tickets online with Goibibo. Bus Ticket Booking for AC Volvo, Sleeper, Luxury and other buses with attractive offers. Get confirmed Bus Reservation tickets at best prices." },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          ]
        }
      />
      <S.HomeBodyWrapperSection id="srpCardLayout">

        {showNextDayPopup ?
          <div ref={NotFoundPopupRef} >
            <Modal render={() => <NotFoundPopup headerDate={dateformat(tommorrowDate, 'dd mmm')} currentDate={dateformat(dojObj, 'dd mmm')} onClickCB={() => {
              let tommorrowDate = dojObj;
              tommorrowDate.setDate(dojObj.getDate() + 1);
              dispatch(
                fetchSrpDataThunk({
                  src,
                  dest,
                  src_id: src_vid,
                  dest_id: dest_vid,
                  doj: dateformat(tommorrowDate, 'yyyymmdd'),
                  src_name,
                  dest_name,
                  srcLat,
                  srcLon,
                  destLat,
                  destLon
                }),
              );

              replaceSRPUrlState({
                history,
                search: window.location.search,
                keyName: 'bid',
                inputValues: {
                  src_name: src,
                  dest_name: dest,
                  src_vid,
                  dest_vid,
                  selectedDate: tommorrowDate
                }
              })
              dispatch(setNextDayPopup(false));
            }} />}
              closeBtnCross={false}
              closeBtnFlag={false}
              close={() => {
                console.log("model closed");
                //setShowModal(false)
              }}>
            </Modal>
          </div>
          : null}

        <SearchWidget setSelectedFilters={setSelectedFilters} clearHorizontalFilterCards={clearHorizontalFilterCards} />
        <S.SearchBlockOuterWrapper >
          <SrpMainBlock clearHorizontalFilterCards={clearHorizontalFilterCards} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters}></SrpMainBlock>
        </S.SearchBlockOuterWrapper>
      </S.HomeBodyWrapperSection>
    </>
  );
};

export default SRP;
